import { useTranslation } from "react-i18next";
import { WizardButtons } from "../components/ui/WizardButtons";
import { VehicleCaracteristics } from "../components/summary/VehicleCaracteristics";
import { VehicleAddicionalCaracteristics } from "../components/summary/VehicleAddicionalCaracteristics";
import { FinancialInformation } from "../components/summary/FinancialInformation";
import { AddicionalFinancialInformation } from "../components/summary/AddicionalFinancialInformation";
import { DealerInformation } from "../components/summary/DealerInformation";
import { PersonalData } from "../components/summary/PersonalData";
import { Formik } from "formik";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { Form } from "@vwfs-bronson/bronson-react";
import { Step, SubmitAnswersRequest } from "../interfaces";

export const SummaryPage = () => {
    const { t } = useTranslation("summarypage");
    const { submitAnswersRequest, setSubmitAnswersRequest } = useMatchMakerWizard();
    return (
        <>
            <Formik
                initialValues={submitAnswersRequest}
                onSubmit={() => {
                    setSubmitAnswersRequest((value) => {
                        return {
                            ...value,
                            isEditMode: false,
                            currentStep: Step.FINAL_CONFIRMATION,
                        } as SubmitAnswersRequest;
                    });
                }}
            >
                {(formikProps) => (
                    <Form id="SummaryPageForm" onSubmit={formikProps.handleSubmit }noValidate>
                        <p>{t("summarypage:title")}</p>
                        <VehicleCaracteristics />
                        <VehicleAddicionalCaracteristics />
                        <FinancialInformation />
                        <AddicionalFinancialInformation />
                        <DealerInformation />
                        <PersonalData />
                        <WizardButtons />
                    </Form>
                )}
            </Formik>
        </>
    );
};
